import { css } from 'aphrodite';
import * as React from 'react';
import { getPageWindow } from '../../../utils/Support/getPageWindow';
import { ChevronLeft } from '../../../web/components/svgs/icons/ChevronLeft';
import { ChevronRight } from '../../../web/components/svgs/icons/ChevronRight';
import { Button } from '../../../web/components-v2/Button';
import { inboxStyles as s } from './styles/inboxStyles';

interface TicketPaginationProps {
	page: number;
	totalPages: number;
	onSelectPage: (page: number) => void;
}

/**
 * Numbered pagination bar shared by the mailbox list pane and the table view. Renders nothing when
 * everything fits on one page.
 */
export const TicketPagination: React.FC<TicketPaginationProps> = ({ page, totalPages, onSelectPage }) => {
	if (totalPages <= 1) return null;
	const pageWindow = getPageWindow(page, totalPages);

	return (
		<nav className={css(s.paginationBar)} aria-label='Ticket list pages'>
			<Button
				type='button'
				variant='ghost'
				styles={[s.paginationArrow]}
				aria-label='Previous page'
				disabled={page <= 1}
				onClick={() => onSelectPage(page - 1)}
			>
				<ChevronLeft width={16} height={16} />
			</Button>
			<div className={css(s.paginationPages)}>
				{pageWindow.map(windowPage => {
					const active = windowPage === page;
					return (
						<Button
							key={windowPage}
							type='button'
							variant='ghost'
							styles={active ? [s.paginationPage, s.paginationPageActive] : [s.paginationPage]}
							aria-label={`Page ${windowPage}`}
							aria-current={active ? 'page' : undefined}
							disabled={active}
							onClick={() => onSelectPage(windowPage)}
						>
							{windowPage}
						</Button>
					);
				})}
			</div>
			<Button
				type='button'
				variant='ghost'
				styles={[s.paginationArrow]}
				aria-label='Next page'
				disabled={page >= totalPages}
				onClick={() => onSelectPage(page + 1)}
			>
				<ChevronRight width={16} height={16} />
			</Button>
		</nav>
	);
};
